import { RoutesService, eLayoutType } from '@abpdz/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routes: RoutesService): any {
  return () => {
    routes.add([
      {
        // path: '/clientsBoard',
        path: `/EzynessAdmin/Reporting`,
        name: 'Analytics',
        iconClass: 'pie_chart',
        order: 1,
        layout: eLayoutType.application,
        requiredPolicy: 'EzynessAdmin.Reporting',
      },
      {
        path: '/clientsBoard',
        name: 'Ezyness::Menu:Clients',
        iconClass: 'people',
        order: 2,
        layout: eLayoutType.application,
        requiredPolicy: 'Enrolment.Clients',
      },
      {
        path: '/clientsBoardLPR',
        name: 'Ezyness::Menu:ClientsLPR',
        iconClass: 'groups',
        order: 2,
        layout: eLayoutType.application,
        requiredPolicy: 'Enrolment.LPRClients',
      },
      {
        path: '/clientsBoardSiegeSocial',
        name: 'Ezyness::Menu:SiegesSocial',
        iconClass: 'apartment',
        order: 2,
        layout: eLayoutType.application,
        requiredPolicy: 'Enrolment.SiegeSocial',
      },
    ]);
  };
}
